import { Blog } from "../types";

const AUTHOR = "Shashi Sharma";
const DEFAULT_CONTENT = "Full blog content here...";

const createBlog = (
  id: string,
  title: string,
  excerpt: string,
  coverImage: string,
  publishedAt: string,
  tags: string[],
  readTimeMinutes: number,
  category: string,
): Blog => ({
  id,
  title,
  excerpt,
  content: DEFAULT_CONTENT,
  coverImage,
  publishedAt: new Date(publishedAt),
  author: AUTHOR,
  tags,
  readTimeMinutes,
  category,
});

export const blogs: Blog[] = [
  createBlog(
    "1",
    "Building Scalable Flutter Apps with Clean Architecture",
    "Learn how to structure your Flutter applications using clean architecture principles for better maintainability and testability.",
    "/blog-images/flutter_clean_architecture.png",
    "2024-11-15",
    ["Flutter", "Architecture", "Clean Code"],
    8,
    "Development",
  ),
  createBlog(
    "2",
    "State Management in Flutter: Riverpod vs BLoC",
    "A comprehensive comparison of two popular state management solutions in Flutter ecosystem.",
    "/blog-images/flutter_state_management.png",
    "2024-11-10",
    ["Flutter", "State Management", "Riverpod", "BLoC"],
    12,
    "Development",
  ),
  createBlog(
    "3",
    "Optimizing Flutter Performance for 60 FPS",
    "Essential tips and tricks to ensure your Flutter app runs smoothly at 60 frames per second.",
    "/blog-images/flutter_performance.png",
    "2024-11-05",
    ["Flutter", "Performance", "Optimization"],
    10,
    "Performance",
  ),
  createBlog(
    "4",
    "Firebase Integration Best Practices",
    "Master Firebase integration in Flutter with these proven best practices and security tips.",
    "/blog-images/firebase_integration.png",
    "2024-10-28",
    ["Flutter", "Firebase", "Backend"],
    15,
    "Backend",
  ),
  createBlog(
    "5",
    "Custom Animations in Flutter",
    "Create stunning custom animations that will make your app stand out from the competition.",
    "/blog-images/flutter_animations.png",
    "2024-10-20",
    ["Flutter", "Animation", "UI/UX"],
    7,
    "UI/UX",
  ),
  createBlog(
    "6",
    "Testing Flutter Apps: Unit, Widget, and Integration Tests",
    "A complete guide to testing strategies in Flutter for robust and reliable applications.",
    "/blog-images/flutter_testing.png",
    "2024-10-12",
    ["Flutter", "Testing", "Quality Assurance"],
    14,
    "Quality",
  ),
  createBlog(
    "7",
    "Why Learning C and Low-Level Programming Will Transform Your Career",
    "Discover how understanding low-level programming fundamentals makes you a better developer in any language.",
    "/blog-images/c_and_low_level_programming.jpg",
    "2024-06-28",
    ["Programming", "C", "Career", "Fundamentals"],
    18,
    "Career Advice",
  ),
  createBlog(
    "8",
    "The Art of Asynchronous Programming: From Hardware to High-Level Abstractions",
    "Understanding async programming from CPU registers to event loops—and why the speed gap between hardware components makes it essential.",
    "/blog-images/asynchronous_programming.jpg",
    "2024-05-15",
    ["Async", "Concurrency", "Software Engineering", "Performance"],
    20,
    "Software Engineering",
  ),
  createBlog(
    "9",
    "The Fundamentals of Digital Images: From Pixels to Color Spaces",
    "Explore fundamental image processing concepts including filtering, transformation, and feature detection.",
    "/blog-images/digital_images.jpg",
    "2024-04-10",
    ["Image Processing", "Algorithms", "Computer Vision"],
    16,
    "Computer Science",
  ),
  createBlog(
    "10",
    "Demystifying File Structure: What's Really Inside Your Files",
    "Best practices for organizing project files and folders for maintainable, scalable applications.",
    "/blog-images/file_structure.jpg",
    "2024-03-18",
    ["Best Practices", "Project Structure", "Organization"],
    9,
    "Development",
  ),
  createBlog(
    "11",
    "How CPUs Actually Work: From 8085 to Modern Processors",
    "A deep dive into how CPUs work—from logic gates to instruction pipelines—and what it means for your code.",
    "/blog-images/working_of_cpu.jpg",
    "2024-02-25",
    ["Computer Architecture", "Hardware", "Performance", "Low-Level"],
    22,
    "Computer Science",
  ),
  createBlog(
    "12",
    "Dynamic Linking and FFI: Calling Rust and C from Other Languages",
    "Explore dynamic linking, shared libraries, and Foreign Function Interface (FFI) to understand how programs written in different languages can work together.",
    "/blog-images/dynamic_library.jpg",
    "2024-12-25",
    ["Rust", "C", "FFI", "Dynamic Linking", "Systems Programming"],
    25,
    "Systems Programming",
  ),
  createBlog(
    "13",
    "Mastering Neovim: LSP, Treesitter, and Modern Development Workflow",
    "Dive deep into Neovim's powerful features including Language Server Protocol, Treesitter syntax highlighting, and building a modern IDE-like development environment.",
    "/blog-images/neovim.jpg",
    "2024-11-20",
    ["Neovim", "LSP", "Treesitter", "Vim", "Developer Tools"],
    28,
    "Developer Tools",
  ),
  createBlog(
    "14",
    "Docker and Containerization: From Traditional Deployment to Modern DevOps",
    "Learn how Docker revolutionized application deployment, understand containerization fundamentals, and master Docker basics from images to compose.",
    "/blog-images/docker.jpg",
    "2024-03-04",
    ["Docker", "Containerization", "DevOps", "Deployment", "Infrastructure"],
    30,
    "DevOps",
  ),
  createBlog(
    "15",
    "GitHub Actions: Automate Your Development Workflow",
    "Master GitHub Actions for CI/CD automation. Learn workflows, actions, runners, and build complete pipelines for testing, building, and deploying applications.",
    "blog-images/gh_action.jpg",
    "2024-09-23",
    ["GitHub Actions", "CI/CD", "Automation", "DevOps", "Testing"],
    26,
    "DevOps",
  ),
  createBlog(
    "16",
    "How the Internet Works: IP Addresses, Protocols, and Data Transfer",
    "Explore the fundamentals of the internet, understand how IP addresses work, learn about networking protocols, and discover how data travels across the world in milliseconds.",
    "/blog-images/working_internet.jpg",
    "2024-5-10",
    ["Internet", "Networking", "TCP/IP", "DNS", "Protocols"],
    32,
    "Computer Science",
  ),
  createBlog(
    "17",
    "Shorebird Code Push: Deploy Flutter Updates Instantly Without App Store Delays",
    "Discover how Shorebird enables over-the-air updates for Flutter apps. Learn to deploy bug fixes and features instantly, bypass store reviews, and revolutionize your deployment workflow.",
    "/blog-images/shorebird.jpg",
    "2025-01-14",
    [
      "Flutter",
      "Shorebird",
      "Code Push",
      "OTA Updates",
      "Mobile Development",
      "CI/CD",
    ],
    25,
    "Mobile Development",
  ),
  createBlog(
    "18",
    "Introduction to Dynamic Libraries: How Shared Libraries Work",
    "Dive deep into dynamic libraries and understand how shared libraries work across different platforms. Learn about static vs dynamic linking, PIC, symbol resolution, and how to create your own libraries.",
    "/blog-images/dynamic_library.jpg",
    "2025-02-06",
    [
      "Dynamic Libraries",
      "Shared Libraries",
      "C",
      "Systems Programming",
      "Linking",
      "Low-Level",
    ],
    22,
    "Systems Programming",
  ),
  createBlog(
    "19",
    "Fourier Transform and Fourier Series: Understanding Purpose and Usage",
    "Discover how Fourier analysis decomposes signals into frequencies and powers the technology around us. Learn about its applications in audio compression, image processing, communications, medical imaging, and more.",
    "/blog-images/fourier_transform.jpg",
    "2025-03-11",
    [
      "Fourier Transform",
      "Signal Processing",
      "Mathematics",
      "FFT",
      "Audio Processing",
      "Image Processing",
    ],
    8,
    "Computer Science",
  ),
  createBlog(
    "20",
    "Data Structures Fundamentals: Arrays, Linked Lists, Stacks, and Queues",
    "Master the fundamental data structures every programmer should know. Learn about arrays, linked lists, stacks, and queues with implementations, real-world applications, and common interview problems.",
    "/blog-images/data_structure.jpg",
    "2025-04-22",
    [
      "Data Structures",
      "Algorithms",
      "Programming",
      "Computer Science",
      "Interview Prep",
    ],
    30,
    "Computer Science",
  ),
  createBlog(
    "21",
    "Programming Language Syntax Comparison: Dart, TypeScript, Java, C/C++, and Python",
    "Master multiple programming languages faster with this comprehensive syntax comparison guide. Learn variable declarations, data types, functions, classes, and control structures across five popular languages with side-by-side examples in tabular format.",
    "/blog-images/programming_languages.png",
    "2025-05-18",
    [
      "Programming Languages",
      "Syntax Comparison",
      "Dart",
      "TypeScript",
      "Java",
      "C/C++",
      "Python",
      "Tutorial",
    ],
    25,
    "Programming",
  ),
];
